import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Drawer, Menu } from 'antd'
import Scrollbar from 'react-custom-scrollbars'
import HeaderComponent from 'components/HeaderComponentNew'
import CustomProfileLayout from '../../Dashboard/Clinic/CustomLayout'
import Credentials from '../credentials'
import TherapistShifting from './index'
import CenterGeoLoaction from './CenterGeoLocation'

const tabs = [
  {
    key: 'Credentials',
    title: 'Credentials',
    component: <Credentials />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'Shift-Timings',
    title: 'Shift Timings',
    component: <TherapistShifting />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'attendance-Setting',
    title: 'Attendance Setting',
    component: <CenterGeoLoaction />,
    // iconName: <ProfileOutlined />,
  },
]

const TherapistSettings = props => {
  const [rightComponent, setRightComponent] = useState(<Credentials />)
  const [panelHeading, setPanelHeading] = useState('Credentials')

  const handleMenuChange = item => {
    const selectedItem = tabs.find(tab => tab.key === item.key)
    setPanelHeading(selectedItem.title)
    if (selectedItem) setRightComponent(selectedItem.component)
  }

  return (
    <>
      <CustomProfileLayout
        leftContent={
          <>
            <Menu
              style={{ height: 'calc(100vh - 175px)' }}
              onSelect={handleMenuChange}
              mode="inline"
              defaultSelectedKeys={['Credentials']}
            >
              {tabs.map(tab => {
                if (!tab.submenu) {
                  return (
                    <Menu.Item key={tab.key}>
                      {/* {tab.iconName} */}
                      <span>{tab.title}</span>
                    </Menu.Item>
                  )
                }
                return (
                  <Menu.SubMenu
                    title={
                      <span>
                        {tab.iconName}
                        <span>{tab.title}</span>
                      </span>
                    }
                    key={tab.key}
                    onTitleClick={() => handleMenuChange({ key: tab.key })}
                  >
                    {tab.submenu.map(label => (
                      <Menu.Item key={label[0]}>
                        {label[1]} <span>{label[0]}</span>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                )
              })}
            </Menu>
          </>
        }
        rightContent={
          <>
            <HeaderComponent
              title={panelHeading}
              showHomePath={false}
              pathList={['Therapist Settings']}
            />
            <div style={{ minHeight: 360, margin: '0 10px' }}>
              <Scrollbar style={{ height: 'calc(100vh - 150px)' }}>
                <div>{rightComponent}</div>
              </Scrollbar>
            </div>
          </>
        }
      />
    </>
  )
}
export default TherapistSettings
